import httpService from './httpService';

export default {
  query,
  remove,
  add,
  update,
};

function query(filterBy) {
  let filters = [];
  for (let filterKey in filterBy) {
    const value = filterBy[filterKey];
    if (value !== null && value !== undefined)
      filters.push(filterKey + '=' + value);
  }
  let filterUrlParams = filters.length ? '?' + filters.join('&') : '';
  return httpService.get(`disc${filterUrlParams}`);
}

function remove(discId) {
  return httpService.delete(`disc/${discId}`);
}
function add(disc) {
  return httpService.post(`disc`, disc);
}
// function save(disc) {
//     return disc._id ? _update(disc) : _add(disc)
// }
function update(disc) {
  return httpService.put(`disc/${disc._id}`, disc);
}
